import React, { useState, useEffect } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { BaseURL } from "../../Files/BaseURL";

function Footer() {

  const navigate = useNavigate();
  const [links, setLinks] = useState([]);

  const fetchFooterLinks = async () => {
    try {
      const response = await fetch(`${BaseURL}/api/portfolio/footer`);
      const data = await response.json();
      const formattedLinks = data.map((item, index) => ({
        id: index + 1,
        link: item.nav.link,
        to: item.nav.to
      }));
      setLinks(formattedLinks);
    } catch (error) {
      console.error('Error fetching header links:', error);
    }
  };


  useEffect(() => {
    fetchFooterLinks();
  }, []);


  return (
    <footer className="bg-white text-black py-8 mt-5">
      <div className=" flex container mx-auto px-4 flex-col justify-between items-center">

        <div className="max-h-8 text-center mt-2">
          <h1 className="ml-2 oxygen-bold text-3xl">paycott.</h1>
        </div>

        <div className="flex flex-col sm:flex-row sm:space-x-6 text-center mt-8">
          {links.map((link) => (
            <Link
              to={link.to}
              key={link.id}
              className="px-4 cursor-pointer capitalize font-medium text-black hover:scale-110 duration-200 "
            >
              {link.link}
            </Link>
          ))}
        </div>


        <div className="text-center mt-8">
          <p className='custom-text'>&copy; 2024 Paycott. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
